import { Link } from 'react-router-dom';
import { LATEST_RELEASE } from '../router/routes';

function NotFoundPage() {
  return (
    <div className="not-found-page" style={{ textAlign: 'center', padding: '4rem 2rem' }}>
      <h1>Page Not Found</h1>
      <p>The page you requested does not exist.</p>
      <Link to={`/${LATEST_RELEASE}`}>Go to the latest release</Link>
    </div>
  );
}

export default NotFoundPage;
